module.exports = __webpack_public_path__ + "img/bg-1.be9f6b7b.png";